import { useState } from "react"
import { InputForm } from "../atoms/input"
import { TrueFalse } from "../molecule/trueFalse"
import { VerticalLayout } from "./layout"

export const TrueFalseOptions = ({data, updateContent}) => {
    const [activeButton,setActiveButton] = useState(data?.quiz_answers ? data.quiz_answers[0].quiz_answer:0)
    const [text,setText] = useState(data?.quiz_question ? data.quiz_question:'')
    const handleText =  (text) => {
        const obj = {...data}
        obj.quiz_question = text
        obj.quiz_answer_content = [{quiz_answer:activeButton, quiz_correct_answer:1},{quiz_answer:!activeButton, quiz_correct_answer:0}]
        setText(text)
        updateContent(obj)
    }
    const handleButton =  (button) => {
        const obj = {...data}
        obj.quiz_question = text
        obj.quiz_answer_content = [{quiz_answer:button, quiz_correct_answer:1},{quiz_answer:!button, quiz_correct_answer:0}]
        setActiveButton(button)
        updateContent(obj)
    }

    
    return (
        <VerticalLayout style={{ height : "auto" }}>
            <InputForm
                typeInput={(newText) => handleText(newText)}
                supporting={"Kies of de stelling waar of niet waar is"}
                value={text}
                title={"Stelling:"}
            />
            <TrueFalse activateButton={(value) => handleButton(value)} activeButton={activeButton}/>
        </VerticalLayout>
    )
}